var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColgate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 736 183",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-34.0036,-311.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.503,75.084L184.251,75.084L170.404,118.161L8.503,118.161L8.503,75.084Z",
    style: {
      fill: "rgb(237,28,36)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-34.0036,-311.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.503,75.084L184.251,75.084L170.404,118.161L8.503,118.161L8.503,75.084Z",
    style: {
      fill: "none",
      stroke: "rgb(237,28,36)",
      strokeWidth: "0.31px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-34.0036,-311.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.794,105.531C39.474,102.419 39.581,103.742 39.26,101.452C13.345,108.322 26.801,77.231 44.742,84.995C44.956,84.887 44.564,84.887 48.053,81.453C19.717,69.825 0.814,114.476 39.794,105.531Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-34.0036,-311.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.293,98.197C40.862,92.401 47.484,87.535 53.321,87.535C61.545,87.535 64.855,91.327 64.001,95.943C62.862,102.061 57.273,106.676 49.94,106.569C44.101,106.497 39.759,103.885 40.293,98.197Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-34.0036,-311.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.234,96.623C48.16,92.973 51.862,90.433 54.354,90.719C57.273,90.719 58.305,93.08 56.953,97.946C56.169,101.166 52.61,103.921 49.619,103.349C46.665,102.061 46.309,100.701 47.234,96.623Z",
    style: {
      fill: "rgb(237,28,36)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-34.0036,-311.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.547,87.535L93.013,88.644C74.894,79.485 61.082,115.406 87.816,104.565C87.887,104.959 81.8,114.19 69.91,109.038L67.988,112.794C93.761,118.018 93.797,103.742 99.67,87.642C94.865,87.642 93.547,87.535 93.547,87.535Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-34.0036,-311.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.486,99.664C79.735,96.122 83.794,91.793 85.787,91.363C87.816,90.934 90.415,90.397 91.767,92.007C90.059,100.057 85.645,103.098 82.583,102.991C80.483,102.991 79.7,102.383 79.486,99.664Z",
    style: {
      fill: "rgb(237,28,36)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-34.0036,-311.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.589,92.043L104.156,87.893C122.062,84.458 126.654,88.25 120.246,100.165C119.178,102.991 118.929,103.814 119.249,106.497C115.227,106.497 112.343,106.533 112.343,106.533L112.343,105.174C112.343,105.174 96.68,111.292 97.712,101.059C98.745,91.041 113.34,94.476 116.651,93.438C117.113,88.036 102.589,92.043 102.589,92.043Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-34.0036,-311.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.8,97.267C98.353,95.764 103.016,107.07 113.553,101.31C114.479,98.769 114.515,97.982 114.8,97.267Z",
    style: {
      fill: "rgb(237,28,36)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-34.0036,-311.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.12,90.183L123.272,90.183L124.34,87.07L127.366,87.07L129.11,82.598L136.016,81.381L133.987,87.034L140.822,87.034L139.647,90.147L132.812,90.183C132.812,90.183 128.79,99.664 128.79,99.986C128.79,100.308 126.654,104.852 133.524,102.204C133.631,104.852 133.773,105.388 133.773,105.388C133.773,105.388 117.647,110.862 122.595,98.841C125.764,91.149 126.12,90.183 126.12,90.183Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-34.0036,-311.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.524,97.123C149.935,97.123 155.239,97.016 159.012,97.016C159.511,95.37 162.715,84.709 148.903,86.354C134.2,88.143 131.566,114.225 157.446,104.458C156.093,101.667 155.88,101.238 155.88,101.238C155.88,101.238 144.524,106.891 144.524,97.123Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-34.0036,-311.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.637,93.76C155.773,90.111 149.223,86.283 145.699,93.76L153.637,93.76Z",
    style: {
      fill: "rgb(237,28,36)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-34.0036,-311.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.69,81.131L77.991,81.131L68.735,106.64L62.577,106.64L71.69,81.131Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-34.0036,-311.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.349,84.279C165.918,84.279 166.417,84.422 166.951,84.673C167.449,84.959 167.876,85.352 168.161,85.889C168.446,86.426 168.588,86.962 168.588,87.499C168.588,88.072 168.446,88.608 168.161,89.145C167.876,89.646 167.485,90.039 166.951,90.326C166.452,90.612 165.918,90.755 165.349,90.755C164.815,90.755 164.281,90.612 163.747,90.326C163.248,90.039 162.857,89.646 162.572,89.145C162.288,88.608 162.145,88.072 162.145,87.499C162.145,86.962 162.288,86.426 162.572,85.889C162.857,85.352 163.248,84.959 163.782,84.673C164.281,84.422 164.815,84.279 165.349,84.279ZM165.349,84.816C164.922,84.816 164.459,84.923 164.032,85.173C163.604,85.388 163.284,85.71 163.035,86.175C162.786,86.605 162.679,87.034 162.679,87.499C162.679,88 162.786,88.429 163.035,88.859C163.248,89.288 163.604,89.61 164.032,89.86C164.459,90.111 164.886,90.218 165.349,90.218C165.812,90.218 166.274,90.111 166.702,89.86C167.129,89.61 167.449,89.288 167.698,88.859C167.947,88.429 168.054,88 168.054,87.499C168.054,87.034 167.947,86.605 167.698,86.175C167.449,85.71 167.129,85.388 166.666,85.173C166.239,84.923 165.812,84.816 165.349,84.816ZM163.925,89.324L163.925,85.817L165.135,85.817C165.562,85.817 165.847,85.853 166.025,85.925C166.203,85.996 166.346,86.104 166.452,86.247C166.559,86.426 166.63,86.569 166.63,86.748C166.63,87.034 166.524,87.249 166.346,87.428C166.168,87.606 165.918,87.714 165.634,87.75C165.74,87.785 165.847,87.857 165.918,87.928C166.061,88.072 166.239,88.286 166.452,88.608L166.844,89.324L166.168,89.324L165.883,88.751C165.634,88.322 165.42,88.072 165.278,87.928C165.171,87.857 165.029,87.821 164.815,87.821L164.495,87.821L164.495,89.324L163.925,89.324ZM164.495,87.356L165.171,87.356C165.527,87.356 165.74,87.284 165.847,87.213C165.954,87.106 166.025,86.962 166.025,86.819C166.025,86.712 165.99,86.605 165.954,86.533C165.883,86.461 165.812,86.39 165.705,86.354C165.598,86.318 165.42,86.283 165.135,86.283L164.495,86.283L164.495,87.356Z",
    style: {
      fill: "white"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColgate);
export default __webpack_public_path__ + "static/media/Colgate.dff4676a7bc799a8c1601d91c0f2dd1d.svg";
export { ForwardRef as ReactComponent };